export default "__VITE_ASSET__5aoXPpkF__"